import React from 'react';
import { useSelector } from 'react-redux';
import { translations } from '../../data/translation';

import app_icon from '../../images/app_icon.png';
import ios_black from '../../images/ios_black.svg';
import android_black from '../../images/android_black.svg';

import ios_black_en from '../../images/ios_black_en.svg';
import android_black_en from '../../images/android_black_en.svg';

// 외부 제휴처에 넣는 범용 앱 설치 링크의 착지 페이지.
// 조건 분기와 자동 리다이렉트 없이 항상 같은 화면을 렌더한다.
const ANDROID_STORE =
  'https://play.google.com/store/apps/details?id=com.naegift.app';
const IOS_STORE = 'https://apps.apple.com/kr/app/id6791131122';

export default function AppDownload() {
  const language = useSelector(state => state.language.language);

  const t = translations[language];

  return (
    <section className="app_download_box">
      <img
        className="app_download_icon"
        src={app_icon}
        alt={t.appDownloadIconAlt}
      />
      <h2 className="app_download_title">{t.appDownloadTitle}</h2>

      {/* Apple 배지가 왼쪽, Google 배지가 오른쪽. 순서 고정. */}
      <div className="app_download_badges">
        <a href={IOS_STORE}>
          <img
            className="app_download_badge"
            src={language === 'en' ? ios_black_en : ios_black}
            alt={t.appDownloadAppleAlt}
          />
        </a>
        <a href={ANDROID_STORE}>
          <img
            className="app_download_badge"
            src={language === 'en' ? android_black_en : android_black}
            alt={t.appDownloadGoogleAlt}
          />
        </a>
      </div>
    </section>
  );
}
